import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';
import { Bank } from '../bank';
import { Observable } from 'rxjs/Observable';
import { Branch } from '../branch';
import { TdLoadingService, TdDialogService } from '@covalent/core';
import { BankService } from '../../../shared/services/bank.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  providers: [BankService]
})
export class AccountComponent implements OnInit {
  translatePipe: TranslatePipe = new TranslatePipe();
  currentAccount: Bank = new Bank();
  originalAccount: Bank = new Bank();

  allBranches$: Observable<Branch[]>;

  constructor(
    public _authService: AuthenticationService,
    private _loadingService: TdLoadingService,
    private _bankService: BankService,
    private _location: Location,
    private router: Router,
    private _dialog: TdDialogService
  ) { }

  ngOnInit() {
    this._loadingService.register('loading');

    //this.allBranches$ = this._bankService.getBranches();
    this.allBranches$ = Observable.of(this._authService.getUserBranches());

    this._loadingService.resolve('loading');
  }

  changed(): boolean {
    for (let prop in this.currentAccount) {
      if (this.currentAccount[prop] != this.originalAccount[prop]) {
        return true;
      }
    }

    return false;
  }

  createAccount() {
    let message: string[] = [];

    if(this.currentAccount.name == null) {
      message.push(this.translatePipe.transform('type_a_name_for_the_account', this._authService.getLanguage()));
    }
    if(this.currentAccount.type == null) {
      message.push(this.translatePipe.transform('the_type_of_the_account_is_mandatory', this._authService.getLanguage()));
    }
    if(this.currentAccount.branch_id == null) {
      message.push(this.translatePipe.transform('the_branch_is_mandatory_in_an_account', this._authService.getLanguage()));
    }
    if(this.currentAccount.currency == null) {
      message.push(this.translatePipe.transform('select_a_currency_for_the_account', this._authService.getLanguage()));
    }
    
    if (message.length >0) {
      this._dialog.openAlert({title: this.translatePipe.transform('invalid_input', this._authService.getLanguage()), message: message.join('. ')});
      return;
    }

    this._bankService.createBank(this.currentAccount).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this._dialog.openAlert({title: this.translatePipe.transform('success', this._authService.getLanguage()), message: this.translatePipe.transform('account_created_successfully', this._authService.getLanguage())});
          this.router.navigate(['/accounting', 'bank']);
        } else {
          this._dialog.openAlert({title: this.translatePipe.transform('error', this._authService.getLanguage()), message: this.translatePipe.transform('could_not_create', this._authService.getLanguage()) + ': ' + response['error']});
        }
      },
      error => {
        this._dialog.openAlert({title: this.translatePipe.transform('error', this._authService.getLanguage()), message: this.translatePipe.transform('could_not_create', this._authService.getLanguage()) + ': ' + error});
      }
    );
  }

  saveAccount() {
    // Can't save an account today.
  }

  goBack() {
    this._location.back();
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/accounting/account/account.component.ts